<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="close">
        <div
          class="modal-container"
          @click.stop
          :style="{ backgroundColor: bgColor, color: color, width: width }"
        >
          <div class="grid-container genderSelection">
            <div class="close" @click="close"></div>
            <div class="grid-x">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    item: Object,
    bgColor: {
      default: "#3a3c8a",
    },
    color: {
      default: "#fff",
    },
    width: String,
  },
  data() {
    return {
      id: null,
      day: null,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.day = this.item;
  },
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  color: #fff;
  width: auto;
  max-width: 100%;
  margin: 0px auto;
  padding: 20px 0px;
  background-color: #3a3c8a;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  @media screen and (min-width: 700px) {
    max-width: 611px;
    padding: 48px 70px;
  }
  .close {
    position: absolute;
    right: 10px;
    top: -10px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    &:before,
    &:after {
      width: 20px;
    }
  }
  .genderSelection {
    position: relative;
    padding-top: 2rem;
    padding-bottom: 1rem;
    label {
      &.none {
        text-decoration: underline;
      }
      padding: 1rem;
      width: 100%;
      border-radius: 2px;
      color: #fff;
      &:hover {
        background-color: #515195;
      }
      margin-left: 0;
    }
    [type="radio"] + label {
      max-width: calc(100% - 20px);
    }
    input[type="radio"]:checked + label {
      border: 0;
      background-color: #515195;
    }
  }
  .icon.fill {
    max-width: 100%;
    padding-bottom: 100%;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/common/ModalGeneric.vue